import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15d523bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-table-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ved login vil brugeren blive bedt om at sætte et nyt password.", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_edit_user_form = _resolveComponent("edit-user-form")!
  const _component_create_user_form = _resolveComponent("create-user-form")!
  const _component_confirm_modal = _resolveComponent("confirm-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_button, {
      class: "mb-2",
      variant: "success",
      onClick: _ctx.createUser
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Opret Bruger ")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_b_table, {
      striped: "",
      hover: "",
      busy: _ctx.loading,
      items: _ctx.users,
      fields: _ctx.userFields
    }, {
      "cell(actions)": _withCtx((row) => [
        _createVNode(_component_b_button, {
          variant: "primary",
          size: "sm",
          onClick: ($event: any) => (_ctx.editUser(row)),
          class: "m-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Ret ")
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_b_button, {
          size: "sm",
          onClick: ($event: any) => (_ctx.resetPassword(row)),
          class: "m-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Nulstil kodeord ")
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_b_button, {
          variant: "danger",
          size: "sm",
          onClick: ($event: any) => (_ctx.confirmDeleteUser(row)),
          class: "m-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" X ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["busy", "items", "fields"]),
    _createVNode(_component_b_modal, {
      "model-value": _ctx.showNewPasswordModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showNewPasswordModal) = $event)),
      title: "Nyt kodeord"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createTextVNode("Brugeren "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.changedUser?.userName), 1),
          _createTextVNode(" har fået nulstillet sit password. Det midlertidige password er:")
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.newPassword), 1)
        ]),
        _hoisted_2
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_edit_user_form, {
      "show-form": _ctx.showEditUserForm,
      "onUpdate:showForm": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showEditUserForm) = $event)),
      user: _ctx.changedUser,
      onSubmitted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refresh')))
    }, null, 8, ["show-form", "user"]),
    _createVNode(_component_create_user_form, {
      "show-form": _ctx.showCreateUserForm,
      "onUpdate:showForm": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCreateUserForm) = $event)),
      onSubmitted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('refresh')))
    }, null, 8, ["show-form"]),
    _createVNode(_component_confirm_modal, {
      "show-modal": _ctx.showConfirmDeleteModal,
      "onUpdate:showModal": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showConfirmDeleteModal) = $event)),
      title: 'Slet bruger' + _ctx.userToBeDeleted.name,
      description: `Er du sikker på at du vil slette ${_ctx.userToBeDeleted.name}`,
      onConfirmed: _ctx.deleteUser
    }, null, 8, ["show-modal", "title", "description", "onConfirmed"]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}